import {EventEmitter} from '@billjs/event-emitter';
import { gsap } from "gsap";
import { unmute } from './unmuteios.js';
import SimpleReverb from 'soundbank-reverb';

const MOBILE_OS = getMobileOperatingSystem();

// hack iOS (see musical canvas)
const ua = navigator.userAgent.toLowerCase();
const isIOS =
  (ua.indexOf('iphone') >= 0 && ua.indexOf('like iphone') < 0) ||
  (ua.indexOf('ipad') >= 0 && ua.indexOf('like ipad') < 0) ||
  (ua.indexOf('ipod') >= 0 && ua.indexOf('like ipod') < 0);



function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }
  return null;
}

export default class MusicLMManager extends EventEmitter{

  constructor() {
    super();
    this.prevBuffers = {};
    this.muted = false;

    this.channels = 1;
    this.useMonoToStereo = true;
    this.endpoint = "musiclmPG"
    // (this.channels == 1) ? "musiclm" : "musiclm2";

  }

  async preloadMusicLMTrack(prompt,id,levelName,prefixStyle,type="prefix"){

    ///------> MAKE REQUEST
    // console.log("preloadMusicLMTrack",id);
    console.log(prompt,id,levelName,prefixStyle,type);
    const result = await this.callApi(levelName,prefixStyle,type);

    // console.log(result);
    // let decodedRaw = this.decodedRawAudio( result['generateMusicResponse']['audios'][0]['rawSamples'] );

    let returnedError = false;

    // process result
    if ('error' in result && result.error === true) {
      console.log("ERROR",id);
      returnedError = true;
      this.handleMusicLMLoadError(id);
    }
    else if ('audio' in result) {
      console.log("Loaded: ",id);
      const wav = result.audio;
      this.prevBuffers[id] = {audio:wav,prompts:prompt,finalPrompt:result['prompt'],channels:this.channels};
      // console.log(result['prompt']);
      // document.getElementById("prompt-debug").innerText = result['prompt'];
    }
    // else if ('results' in result && result.results.length) {
    //   console.log("Loaded: ",id);
    //   const wav = result.results[0].audioData.data;
    //   this.prevBuffers[id] = {audio:wav,prompts:prompt,finalPrompt:result['prompt']};
    //   // console.log(result['prompt']);
    //   // document.getElementById("prompt-debug").innerText = result['prompt'];
    // }
    else {
      console.log("ERROR",result);
      returnedError = true;
    }


  }

  async handleMusicLMLoadError(id, levelName = null){
    if(this.channels == 2 )
      return false;
    let backupIds = ["celebration","collaboration","empowered","harmony","hope","trust","strength","unity","welcoming","kalimba_all","trees","resilience","bravery","progress","motivation","happy","uplifting","energy","excitement","grow","bass_all","pond","clouds","floor","treeslow","centertree","bridge","leaf"];
    if(id == "final"){
      await this.loadLocalMusicLMBackup("music_fx_kalimba_all.mp3",id);
      return true;
    }else if((id == "trees" || id == "treeslow") && levelName == "spirit"){
      let filename = "music_fx_" + id.toLowerCase() + "_" + levelName + ".mp3";
      await this.loadLocalMusicLMBackup(filename,id);
      return true;
    }else if( backupIds.includes(id) ){
      let filename = "music_fx_" + id.toLowerCase() + ".mp3";
      await this.loadLocalMusicLMBackup(filename,id);
      return true;
    }
    return false;
  }

  async loadLocalMusicLMBackup(path,id){
    let fullpath = "./sounds/musiclm_backup/"+path;
    const res = await fetch(fullpath);
    const arrayBuffer = await res.arrayBuffer();
    this.prevBuffers[id] = {audio:arrayBuffer,backup:true,channels:1};
  }

  async callApi(levelName,prefixStyle,type) {
    const body = {
     levelName: levelName,
     prefixStyle: prefixStyle,
     type: type
    };

   const url = `${window.location.origin +(window.location.pathname === "/" ? "" : window.location.pathname)}/${this.endpoint}`;

   const response = await fetch(url, {
     method: 'POST',
     headers: { 'Content-Type': 'application/json' },
     body: JSON.stringify(body),
   });
   return await response.json();
 }

  initAudioContext(){
    this.audioCtx = new AudioContext();
    this.gainNode = this.audioCtx.createGain();
    this.gainNode.gain.value = 0;

    this.reverb = new SimpleReverb(this.audioCtx );
    this.reverb.time = 2; //seconds
    this.reverb.wet.value = 0.7;
    this.reverb.dry.value = 0.7;
    this.reverb.filterType = 'lowpass';
    this.reverb.cutoff.value = 4000; //Hz


    if (MOBILE_OS == 'iOS' || isIOS) {
      unmute(this.audioCtx);
    }
  }

  mute(){
    this.muted = true;
  }

  unmute(){
    this.muted = false;
  }

  async playStoredTrack(trackId,destVol=1){

    console.log("Set from musiclm preload.");
    let wav = this.prevBuffers[trackId]['audio'];
    let channels = this.prevBuffers[trackId]['channels'];

    // let arrayBuffer = await this.dataUrlToArrayBuffers(
    //   'data:audio/wav;base64,' + wav
    // );
    if(channels == 1 ){
      let arrayBuffer;

      if(this.prevBuffers[trackId].hasOwnProperty('backup')){
        arrayBuffer = wav;
      }else{
        arrayBuffer = await this.dataUrlToArrayBuffers(
          'data:audio/wav;base64,' + wav
        );
      }
      const didSet =  await this.setBuffer(arrayBuffer,.001,channels);
      if(didSet && destVol){
        this.fadeInSource(destVol,1);
      }
      return didSet;
    }else if(channels == 2){
      let decodedRaw = this.decodedRawAudio( wav );
      const didSet =  await this.setBuffer(decodedRaw,.001,channels);
      if(didSet && destVol){
        this.fadeInSource(destVol,1);
      }
      return didSet;
    }else{
      return false;
    }


  }

  async dataUrlToArrayBuffers(dataUrl) {
      const res = await fetch(dataUrl);
      return await res.arrayBuffer();
  }

  async setBuffer(dataArray, vol, channels) {

  if (!dataArray) {
    return false;
  }

  if(this.source){
    try{
      this.source.stop();
      this.source.disconnect();
    }catch(e){
      console.log("can't stop source.");
    }

  }

  this.source = this.audioCtx.createBufferSource();


  try{

    if(channels == 2){
      const myArrayBuffer = this.audioCtx.createBuffer(2, dataArray[0].length, 48000);
      let channels = 2;
      for (let channel = 0; channel < channels; channel++) {
        const nowBuffering = myArrayBuffer.getChannelData(channel);
        for (let i = 0; i < dataArray[channel].length; i++) {
          nowBuffering[i] = dataArray[channel][i];
        }
      }
      this.source = this.audioCtx.createBufferSource();
      this.source.buffer = myArrayBuffer;
    }else{
      const buffer = await this.audioCtx.decodeAudioData(dataArray);
      let rawDataArray = buffer.getChannelData(0);
      const floatArray = Float32Array.from(rawDataArray);


      if(this.useMonoToStereo){
        // console.log("mono to stereo ");
          const myArrayBuffer = this.audioCtx.createBuffer(2, floatArray.length, 48000);
          for (let channel = 0; channel < 2; channel++) {
            const nowBuffering = myArrayBuffer.getChannelData(channel);
            for (let i = 0; i < floatArray.length; i++) {
              if(i==0) nowBuffering[i] = floatArray[i];
              else{
                nowBuffering[i] = floatArray[i];// * 1.1;
              }
            }
          }
          this.source = this.audioCtx.createBufferSource();
          this.source.buffer = myArrayBuffer;
      }else{
        this.buffer = new AudioBuffer({
          length: floatArray.length,
          sampleRate: 48000,
        });

        this.buffer.copyToChannel(floatArray, 0);
        this.source = this.audioCtx.createBufferSource();
        this.source.buffer = this.buffer;
      }
      // var merger = this.audioCtx.createChannelMerger(2);

    }

    if(!this.analyser){
     this.analyser = this.audioCtx.createAnalyser();
    }

    this.analyser.fftSize = 128;
    this.bufferLength = this.analyser.frequencyBinCount;
    this.dataArray = new Uint8Array(this.bufferLength);
    this.source.connect(this.analyser);
    this.source.loop = true;

    this.gainNode.gain.value = vol;
    if(this.muted) this.gainNode.gain.value = 0;

    this.gainNode.connect(this.reverb);
    this.source.connect(this.gainNode);
    this.reverb.connect(this.audioCtx.destination);
    this.source.start();

  }catch(e){
    console.log("Could not set buffer.");
    return false;
  }

  return true;

 }

 setLoopStartEnd(start,end){
   this.source.loopStart = start;
   this.source.loopEnd = end;
 }

 fadeOutSource(duration = 1,destVol = .001){
   if(this.source){
     gsap.to(this.gainNode.gain,{value:destVol,duration:duration});
   }
 }

 fadeInSource(vol = .5,duration = 1){
   if(this.muted){
     vol = 0;
   }
   if(this.source){
     gsap.to(this.gainNode.gain,{value:vol,duration:duration});
   }
 }


 // decode audio utils
 decodedRawAudio(rawSamples) {
    let result;
    let numSamples = rawSamples.length / 2;
    let numChannels = 2;
    // if (numChannels === 1) {
    //   result = rawSamples.slice(0, numSamples);
    // } else if (numChannels === 2) {
      result = [
        rawSamples.filter((value, index) => index % 2 === 0).slice(0, numSamples),
        rawSamples.filter((value, index) => index % 2 === 1).slice(0, numSamples),
      ];
    // } else {
    //   throw new Error('Audio must be mono or stereo.');
    // }
    return result;
  }
}
